import { render, staticRenderFns } from "./PritickePack03.vue?vue&type=template&id=05625a0b&scoped=true&"
import script from "./PritickePack03.vue?vue&type=script&lang=js&"
export * from "./PritickePack03.vue?vue&type=script&lang=js&"
import style0 from "./PritickePack03.vue?vue&type=style&index=0&id=05625a0b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05625a0b",
  null
  
)

export default component.exports